import React from 'react';
import classnames from 'classnames';
import { useRecoilValue } from 'recoil';
import { NavCategorySet, SelectCategory } from '../../../models/NavCategorySet.model';
import { ViewProduct } from '../../../models/ViewProduct.model';
import { productsState } from '../../../recoil/selectors';
import { MobileNavMenuLink } from './MobileNavMenuLink';
import styles from './MobileNavMenuCategory.module.scss';
import { Icon } from '../../../icons/Icon';
import { ImageLoader } from '../../../product_detail/components/ImageLoader';
import { navCategoryImageLookupFn } from '../../../hooks/actions/useNavCategories';
import { assetPathFn } from '../../../util';
import { Link } from '../../../root/components/Link';
import { sortByPopularity } from '../../../collection/components/CollectionCards';
import { navLink } from './MobileNavMenu';

interface Props {
  navCategorySet: NavCategorySet;
  selectCategory: SelectCategory;
  active: boolean;
  index: number;
}

export const MobileNavMenuCategory: React.FC<Props> = ({ navCategorySet, selectCategory, active, index }) => {
  const allProducts = useRecoilValue(productsState);
  const products: ViewProduct[] = Object.values(allProducts);

  const { title, link, productTags } = navCategorySet;
  const imageLookup = navCategoryImageLookupFn(assetPathFn);
  const image = imageLookup(navCategorySet.navCategory, 'small');

  const filteredProducts = products.filter(({ tags, hiddenInMenus }) => tags.some((t) => productTags?.includes(t)) && !hiddenInMenus).sort(sortByPopularity);

  return (
    <React.Fragment>
      <div key={index} className={classnames(styles.hlNavSublinkWrapper, styles.hlMobileNavCategory)}>
        {image && <ImageLoader src={image} alt={navCategorySet.title} style={{ minWidth: 60, height: 60, marginLeft: 12, marginTop: 6 }} />}
        {productTags && productTags.length > 0 && (
          <button
            data-track-label={title}
            data-track-location="mobile-menu"
            className={styles.hlMobileNavLink}
            onClick={() => selectCategory(active ? undefined : navCategorySet)}
          >
            <div className={styles.hlProductMobileNavDescription}>
              <span>{title}</span>
            </div>
            <div>
              <Icon name={active ? 'chevron-up' : 'chevron-down'} style={{ width: '14px' }} />
            </div>
          </button>
        )}
        {productTags && productTags.length === 0 && (
          <div className={classnames(styles.hlNavSublinkWrapper, styles.hlMobileNavCategory)}>
            <Link dataTrackLabel={title} dataTrackLocation="mobile-menu" href={link} text={title} />
          </div>
        )}
      </div>
      <div className={classnames(styles.hlMobileNavProducts, { [styles.active]: active })}>
        <div style={{ minHeight: 77, marginLeft: 92, display: 'flex' }}>
          <Link
            size={'large'}
            dataTrackLabel="Mobile Navigation"
            dataTrackLocation="Mobile Navigation"
            href={navCategorySet.link}
            text={`All ${navCategorySet.title}`}
            labelStyleOptions={{ color: '#6065e0' }}
            fullWidth={true}
            noMargin={true}
          />
        </div>
        {filteredProducts.map((product, i) => (
          <MobileNavMenuLink product={product} index={i} key={i} />
        ))}
      </div>
    </React.Fragment>
  );
};

export default MobileNavMenuCategory;
